var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { attrs: { id: "appFooter" } }, [
    _vm._v("Error Tracker " + _vm._s(_vm.serverVersion))
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }